import React from "react";
import "./navbar.css";

function Navbar() {
  return (
    <nav className="navbar">
      <ul>
        <li><a href="#hero">Home</a></li>
        <li><a href="#about">About Us</a></li>
        <li><a href="#collections">Collections</a></li>
        <li><a href="#whychoose">Why Choose Us</a></li>
        <li><a href="#testimonials">Testimonials</a></li>
        <li><a href="#footer">Contact</a></li>
      </ul>
    </nav>
  );
}

export default Navbar;
